import React, { useContext } from "react"
import { TrashIcon, CollectionIcon, PencilIcon } from "@heroicons/react/outline"
import { AuthContext } from "../../context/auth.context"
import { EndpointConfig } from "../../config"
import { axiosInstance } from "../../lib/axios"
import Button from "../atoms/button.atom"
import { toast } from "react-toastify"
import { Header } from "../common/header"
import Modal from "../atoms/modal.atom"
import Loader from "../loader/loader.component"
import { getCookie } from "../../helper/auth"

export const AllSenderId = ({ hubId, onAddRecord, onUpdateRecord }) => {
	const { auth, setAuth } = useContext(AuthContext)
	const [configs, setConfigs] = React.useState([])
	const [records, setRecords] = React.useState([])
	const [loading, setLoading] = React.useState(false)
	const [isModalVisible, setIsModalVisible] = React.useState(false)
	const [recordId, setRecordId] = React.useState()

	const getConfigs = () => {
		setLoading(true)
		;(async () => {
			const token = getCookie("token")
			const res = await axiosInstance.get(EndpointConfig.hubAppConfig, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
			const allConfigsRes = res.data.data || []
			setConfigs(allConfigsRes)
			// getting all records
			const resRecord = await axiosInstance.get(EndpointConfig.hubAppConfigSender, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
			const allRecordRes = (resRecord.data.data || []).map((senderObj) => {
				const thatConfig = allConfigsRes.find(
					(config) => config._id === senderObj.smsConfigId
				)
				return {
					...senderObj,
					smsConfigName: thatConfig?.name || "",
					userId: thatConfig?.userId || ""
				}
			})
			// mapping records to configs
			setRecords(allRecordRes)
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	React.useEffect(() => {
		getConfigs()
	}, [])

	const deleteRecord = () => {
		setIsModalVisible(false)
		setLoading(true)
		;(async () => {
			const token = getCookie("token")
			await axiosInstance.delete(EndpointConfig.hubAppConfigSender, {
				headers: { Authorization: `Bearer ${token}` },
				data: { recordId }
			})
			toast("Deleted Successfully")
			getConfigs()
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	const editRecord = ({ recordId }) => {
		setLoading(true)
		;(async () => {
			const token = getCookie("token")
			const res = await axiosInstance.get(EndpointConfig.hubAppConfigSender, {
				headers: { Authorization: `Bearer ${token}` },
				data: { recordId }
			})
			const selectedData = res.data.data.find((c) => c._id === recordId)
			setAuth({ hubId: hubId, passData: selectedData })
			onUpdateRecord()
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	return (
		<>
			<Modal
				children={
					<div className="flex font-sans">
						<form className="flex-auto p-6">
							<div className="flex flex-wrap">
								<h1 className="flex-auto text-lg font-semibold text-slate-900">
									Delete
								</h1>
								<div className="flex-none w-full mt-2 text-sm font-normal text-slate-700">
									Are you sure you want to delete this configuration? Click Yes to
									Proceed.!
								</div>
							</div>
							<div className="flex my-5 mb-1 space-x-4 text-sm font-medium">
								<div className="flex items-end justify-end flex-auto space-x-4">
									<button
										className="h-10 px-6 font-semibold text-white bg-blue-700 rounded-md"
										type="submit"
										onClick={() => deleteRecord()}
									>
										Yes
									</button>
									<button
										className="h-10 px-6 font-semibold border rounded-md border-slate-500 text-slate-900"
										type="button"
										onClick={() => setIsModalVisible(false)}
									>
										No
									</button>
								</div>
							</div>
						</form>
					</div>
				}
				toggle={() => setIsModalVisible(false)}
				open={isModalVisible}
			/>
			<div className="flex flex-col">
				<Header
					IconName={CollectionIcon}
					subText={"List"}
					mainText={"SMS Sender Id"}
					postComponent={
						<Button className="w-full" onClick={onAddRecord}>
							Add New Sender Id
						</Button>
					}
				/>

				{loading ? (
					<Loader />
				) : (
					<>
						{" "}
						<div className="flex flex-col pb-4 overflow-x-auto bg-white rounded">
							<div className="inline-block min-w-full py-2">
								<table className="common">
									<thead className="">
										<tr className="">
											<th className="">Record Name</th>
											<th className="">SMS Config Name</th>
											<th className="">User Id</th>
											<th className="">Sender Id</th>
											<th className="">Actions</th>
										</tr>
									</thead>
									<tbody>
										{records.map((record) => (
											<tr key={record._id}>
												<td className="font-medium">{record.name}</td>
												<td className="">{record.smsConfigName}</td>
												<td className="">{record.userId}</td>
												<td className="">{record.senderId}</td>
												<td className="">
													<div className="flex flex-row gap-2">
														<TrashIcon
															className="w-4 h-4 text-red-500 cursor-pointer"
															onClick={() => {
																setRecordId(record._id)
																setIsModalVisible(true)
															}}
														/>
														<PencilIcon
															className="w-4 h-4 text-blue-500 cursor-pointer"
															onClick={() =>
																editRecord({ recordId: record._id })
															}
														/>
													</div>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					</>
				)}
			</div>
		</>
	)
}
